<div class="h-100 d-flex flex-column align-items-center justify-content-center">
    <div class="fade-in">
        <img width="300" src="../../../assets/images/logo-2.png" alt=""/>
    </div>
    
    <br>
    <div class="tagline">
        <p>Automate Your Engineering</p>
    </div>
    <br>
    <div class="message">
        Innactive User
    </div>
    <div class="sub-message">User is innactive! &nbsp; Please contact your admin.</div>
    <br>
</div>